import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { GraphPirog } from '../../../components/tree+two/GraphPirog'; 
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const GraphPirogPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                    <title>Поставщики</title>
                </Helmet>
            <GraphPirog/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default GraphPirogPage
